// Copyright (c) 2015, YangtzeSoft Technologies. and Contributors
// MIT License. See license.txt

if (yangtze.require) {
	yangtze.require("file_uploader.bundle.js");
} else {
	yangtze.ready(function () {
		yangtze.require("file_uploader.bundle.js");
	});
}
